import { render, staticRenderFns } from "./JiShiCancelWait.vue?vue&type=template&id=2c2dda3c&scoped=true"
import script from "./JiShiCancelWait.vue?vue&type=script&lang=js"
export * from "./JiShiCancelWait.vue?vue&type=script&lang=js"
import style0 from "./JiShiCancelWait.vue?vue&type=style&index=0&id=2c2dda3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2dda3c",
  null
  
)

export default component.exports